export var VALIDATE_COUPON_REQUEST = 'VALIDATE_COUPON_REQUEST';
export var VALIDATE_COUPON_SUCCESS = 'VALIDATE_COUPON_SUCCESS';
export var VALIDATE_COUPON_ERROR = 'VALIDATE_COUPON_ERROR';
